"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrievePayoutsOptions = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const SortingPaginationOptions_1 = require("./SortingPaginationOptions");
class RetrievePayoutsOptions extends SortingPaginationOptions_1.SortingPaginationOptions {
}
exports.RetrievePayoutsOptions = RetrievePayoutsOptions;
__decorate([
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], RetrievePayoutsOptions.prototype, "ids", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : (0, utils_1.valueOrArrayToArray)(value))),
    __metadata("design:type", Array)
], RetrievePayoutsOptions.prototype, "userIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], RetrievePayoutsOptions.prototype, "payoutGatewayIds", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : !!(value == "true" || value == true))),
    __metadata("design:type", Boolean)
], RetrievePayoutsOptions.prototype, "hasBaselessAmount", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : (0, utils_1.valueOrArrayToArray)(value).map((item) => Number(item)))),
    __metadata("design:type", Array)
], RetrievePayoutsOptions.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : (0, utils_1.valueOrArrayToArray)(value).map((item) => Number(item)))),
    __metadata("design:type", Array)
], RetrievePayoutsOptions.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value))),
    __metadata("design:type", Date)
], RetrievePayoutsOptions.prototype, "createdAtFrom", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value))),
    __metadata("design:type", Date)
], RetrievePayoutsOptions.prototype, "createdAtTo", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value))),
    __metadata("design:type", Date)
], RetrievePayoutsOptions.prototype, "statusChangedAtFrom", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value))),
    __metadata("design:type", Date)
], RetrievePayoutsOptions.prototype, "statusChangedAtTo", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RetrievePayoutsOptions.prototype, "currency", void 0);
//# sourceMappingURL=RetrievePayoutsOptions.js.map